exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".md-just-icon[data-v-3b5d9c59] {\n  margin-right: 2px;\n}\n", ""]);

// exports
